import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "@/components/sidebar";
import { ThemeToggle } from "@/components/theme-toggle";

const pageTitles: Record<string, string> = {
  "/": "Dashboard",
  "/forms": "İletişim Formları",
  "/users": "Kullanıcılar",
  "/settings": "Ayarlar",
  "/data/nace": "NACE Kodları",
  "/data/ek3": "EK-3 Listesi",
  "/data/regions": "Bölgeler",
};

export function AdminLayout() {
  const location = useLocation();
  const title =
    pageTitles[location.pathname] ||
    (location.pathname.startsWith("/forms/") ? "Form Detayı" : "Admin Panel");

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />

      {/* Main content */}
      <div className="lg:pl-64">
        {/* Top bar */}
        <header className="sticky top-0 z-30 flex h-16 items-center justify-between border-b border-border bg-background/80 px-6 backdrop-blur-sm">
          <div className="ml-12 lg:ml-0">
            <h1 className="text-lg font-semibold text-foreground">{title}</h1>
          </div>
          <ThemeToggle />
        </header>

        {/* Page content */}
        <main className="animate-fade-in p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
